import { render } from "./LegalPageTemplate.vue?vue&type=template&id=7c44eed7"
import script from "./LegalPageTemplate.vue?vue&type=script&lang=js"
export * from "./LegalPageTemplate.vue?vue&type=script&lang=js"

import "./LegalPageTemplate.vue?vue&type=style&index=0&id=7c44eed7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__